import { Box, Typography, Stack, Paper } from "@mui/material";

function Section({ title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: "1px solid #e5e7eb",
        p: { xs: 2.5, md: 3.5 },
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          color: "primary.main",
          fontSize: "1.2rem",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      <Stack spacing={1}>{children}</Stack>
    </Paper>
  );
}

function Item({ children }) {
  return (
    <Typography
      sx={{
        fontSize: "0.98rem",
        lineHeight: 1.7,
      }}
    >
      • {children}
    </Typography>
  );
}

function Text({ children, mb = 0 }) {
  return (
    <Typography
      sx={{
        fontSize: "0.98rem",
        lineHeight: 1.7,
        mb,
      }}
    >
      {children}
    </Typography>
  );
}

function SubTitle({ children }) {
  return (
    <Typography
      sx={{
        fontWeight: 700,
        color: "text.primary",
        fontSize: "1rem",
        mt: 0.5,
      }}
    >
      {children}
    </Typography>
  );
}

function RulesPortugues() {
  return (
    <Stack spacing={3}>
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.4rem",
          color: "primary.main",
        }}
      >
        Apêndice C: Basquete
      </Typography>

      <Typography sx={{ fontWeight: 700 }}>
        FIBA (edição mais recente)
      </Typography>

      <Section title="Exceções às regras">
        <Item>Os jogadores não precisam usar meias da mesma cor.</Item>
      </Section>

      <Section title="Tempo de jogo">
        <Text mb={0.5}>
          Aquecimento: Os períodos de pré-jogo e intervalo na quadra do torneio são reservados exclusivamente para as equipes participantes que estiverem trajadas com seus uniformes oficiais.
        </Text>

        <Item>4 x 8 moedas de 25 centavos para um jogo - relógio parado.</Item>
        <Item>Intervalo de 10 minutos.</Item>
        <Item>2 minutos entre os quartos.</Item>
        <Item>8 segundos para levar a bola até o meio da quadra.</Item>
        <Item>Cronômetro de 24 segundos.</Item>
        <Item>
          Os períodos de prorrogação têm metade da duração de um quarto normal – 4 minutos para jogos de torneio.
        </Item>
        <Item>
          O tempo não será parado nos últimos 2 minutos se uma das equipes estiver vencendo por 25 pontos ou mais. As mesmas regras se aplicam durante a prorrogação.
        </Item>
        <Item>
          O árbitro dará o sinal de início às equipes após 7 minutos do período de aquecimento de 10 minutos.
        </Item>
        <Item>Aplicam-se as regras de tempo limite da FIBA.</Item>
        <Item>
          Uma equipe que vence por 25 pontos ou mais não tem permissão para pressionar a quadra toda.
        </Item>
      </Section>

      <Section title="Listas">
        <Text>
          O Manual da SAAC define os limites de jogadores por equipe para cada modalidade esportiva. No basquete, o limite máximo é de 10 meninos e 10 meninas. É necessário um mínimo de 7 jogadores para que a equipe possa participar de torneios de basquete sancionados pela SAAC. As listas de jogadores devem ser enviadas com duas semanas de antecedência do torneio.
        </Text>
      </Section>

      <Section title="Substituição">
        <Text>Conforme permitido pelas regras da FIBA.</Text>
      </Section>

      <Section title="Equipamento">
        <Text>
          Os meninos usarão a bola de basquete tamanho 7 e as meninas usarão a bola de basquete tamanho 6.
        </Text>
      </Section>

      <Section title="Instalações">
        <Text>
          É necessário ter pelo menos duas quadras de basquete de tamanho oficial com placar eletrônico.
        </Text>
        <Text>
          Recomenda-se que as escolas que sediarem jogos de basquete tenham cronômetros de 24 segundos visíveis.
        </Text>
      </Section>

      <Section title="Uniformes">
        <Text>Todas as equipes devem ter uniformes claros e escuros.</Text>
      </Section>

      <Section title="Autoridades">
        <Text>
          A origem dos funcionários será determinada pela escola anfitriã. Sempre que Se possível, a escola anfitriã deve utilizar as organizações esportivas internacionais do país anfitrião. Arbitrar torneios.
        </Text>
        <Text>
          Basquetebol: 2-3 por mesa + 6 árbitros para revezamento (4 em quadra, 2 fora) *3 equipes de arbitragem.
        </Text>
      </Section>

      <Section title="Classificações e registros">
        <Text mb={0.5}>
          As equipes serão classificadas de acordo com seus registros de vitórias e derrotas, utilizando o seguinte sistema:
        </Text>

        <Item>Dois (2) pontos para cada jogo vencido.</Item>
        <Item>Um (1) ponto para cada jogo perdido.</Item>
        <Item>Zero (0) pontos para um jogo perdido por desistência.</Item>
      </Section>

      <Section title="Critério de desempate na fase de grupos">
        <Text mb={0.5}>
          A SAAC utilizará as regras oficiais da FIBA para a classificação das equipes.
        </Text>

        <SubTitle>FIBA TIE-WREAKER 2020 (6/21 - Idioma incluído)</SubTitle>

        <Text>
          As equipes serão classificadas de acordo com seu histórico de vitórias e derrotas, ou seja, em 2 categorias. Pontos para cada jogo ganho, 1 ponto de classificação para cada jogo perdido (incluindo derrotas por padrão) e 0 ponto de classificação para um jogo perdido por desistência.
        </Text>

        <Text>
          D.1.2 O procedimento deve ser aplicado a todas as competições com sistema de todos contra todos.
        </Text>

        <Text>
          D.1.3 Se duas ou mais equipes tiverem o mesmo registro de vitórias e derrotas em todos os jogos do grupo, a classificação será definida pela(s) partida(s) entre essas duas ou mais equipes. Se essas duas equipes ou mais equipes tiverem o mesmo histórico de vitórias e derrotas nos jogos entre elas, além disso os critérios serão aplicados na seguinte ordem:
        </Text>

        <Item>
          Maior diferença de pontos entre os jogos disputados entre eles.
        </Item>
        <Item>
          Maior número de pontos marcados nos jogos entre eles.
        </Item>
        <Item>
          Maior diferença de pontos entre os jogos contra adversários comuns.
        </Item>
        <Item>
          Maior número de pontos marcados nos jogos contra adversários comuns.
        </Item>
        <Item>
          Maior diferença de pontos entre todos os jogos do grupo.
        </Item>
        <Item>
          Maior número de pontos marcados em todos os jogos do grupo.
        </Item>

        <Text>
          Caso o empate persista antes de todas as partidas do grupo serem disputadas, as equipes empatadas dividirão o resultado mesma classificação. Se esses critérios ainda não forem suficientes para decidir ao final da fase de grupo, um sorteio definirá a classificação final.
        </Text>

        <Text>
          D.1.4 Se, em qualquer nível destes critérios, uma ou mais equipes já estiverem classificadas, o procedimento de D.1.3 deverá ser repetido desde o início para todas as equipes restantes. Ainda não classificado.
        </Text>

        <SubTitle>
          Caso as equipes empatadas não tenham se enfrentado na fase de grupos
        </SubTitle>

        <Item>
          Maior diferença de pontos entre os jogos contra adversários comuns.
        </Item>
        <Item>
          Maior número de pontos marcados nos jogos contra adversários comuns.
        </Item>
        <Item>
          Maior diferença de pontos entre todos os jogos do grupo.
        </Item>
        <Item>
          Maior número de pontos marcados em todos os jogos do grupo.
        </Item>

        <Text>
          Caso o empate persista antes de todas as partidas do grupo serem disputadas, as equipes empatadas dividirão o resultado mesma classificação. Se esses critérios ainda não forem suficientes para decidir ao final da fase de grupo, um sorteio definirá a classificação final.
        </Text>

        <Text>
          D.1.4 Se, em qualquer nível destes critérios, uma ou mais equipes já estiverem classificadas, o procedimento de D.1.3 deverá ser repetido desde o início para todas as equipes restantes. Ainda não classificado.
        </Text>
      </Section>
    </Stack>
  );
}

export default RulesPortugues;